import React, { useEffect, useRef } from "react";
import { StaticImage } from "gatsby-plugin-image";

import { Typography, Button } from "@novaescola/eva-react-v2";

import { useInView } from "../../hooks/useInView";

const GeneralSkills = () => {
  const generalSkillsRef = useRef(null);

  const isInView = useInView(generalSkillsRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "JORNALISMO: bloco temático - competências gerais - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "JORNALISMO: bloco temático - competências gerais - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <div className="theme-block eva-card eva-bg-inst-50 eva-mb-06">
      <div className="eva-card-info">
        <Typography variant="title" size={6} className="eva-mb-04" asChild>
          <p ref={generalSkillsRef}>
            <i className="fa-regular fa-star eva-mr-03 eva-body-2"></i>
            Competências Gerais na BNCC
          </p>
        </Typography>
        <StaticImage
          src="https://thumbor.novaescola.org.br/VdhBFFOjw-DFRfd1O7JBTdYXxOQ=/nova-escola-producao.s3.amazonaws.com/zPpx6Jbxn5XvwQYNZjkKNad3R55M5yZWrbVFSeP6BSBgsC9HcDwuAB6bd97D/cursos-ajudam-professores-a-se-prepararem-para-2023.jpg"
          alt=""
          width={328}
          height={184}
          className="eva-mb-06"
        />
        <Typography variant="body" size={2} className="eva-mb-06">
          Conclua o curso online em 4h e ganhe um certificado!
        </Typography>
        <Button variant="outline-primary" size="medium" asChild>
          <a
            type="button"
            className="eva-btn-full eva-mt-02"
            href="https://cursos.novaescola.org.br/curso/11324/coordenador-pedagogico-do-planejamento-a-formacao/resumo"
            data-track="JORNALISMO: bloco temático - competências gerais - clique no botão"
          >
            COMEÇAR AGORA
          </a>
        </Button>
      </div>
    </div>
  );
};

export default GeneralSkills;
